<div class="MainBg">
    <div class="NewHeadOuter" style="padding-right: 15px;padding-left: 12px;">
        <div>
            <div class="SectionTopHeading_n">&nbsp;&nbsp;Earning Report</div>
            <div class="SubHeader"></div>
        </div>
        <a class="RightSideLink" (click)="GoToDashboard()" routerLinkActive="active"><i
                class="fa fa-long-arrow-left"></i>&nbsp;Report Dashboard&nbsp;</a>
    </div>

    <div class="MainInnerFormWithoutFlex" >
        <div class="FormTemplate">
            <div class="MinLeftFromHeightTransact">
                <app-clients-filter [isMultiSelect]="isMultiSelect" [isShowClientFilter]="isShowClientFilter"
                    [FilterType]="FilterType" [DDLFilterType]="DDLFilterType" (FilterData)="ClientFilterData($event)"
                    [DashboardUserId]="DashboardUserId" [DashboardUserRole]="DashboardUserRole"></app-clients-filter>
            </div>
        </div>
        <div>
            <div class="UnderLineTabs" id="Earning_Reports" [ngClass]="MainActiveMenu == 'mf' ? 'active show' : ''">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a [ngClass]="SubActiveMenu == 'portfolio' ? 'active' : ''" class="nav-link active"
                            data-toggle="tab" routerLinkActive="active" data-target="#pills-home" role="tab" (click) = "tabSummary()">
                            <img class="TabImg svg" type="image/svg+xml"
                                pluginspage="http://www.adobe.com/svg/viewer/install/"
                                src="../../../assets/images/JM/Portfolio_Reports/PortfolioReportsHeading_InActive.svg"
                                alt="">
                            <span *ngIf="!IsMobile">Summary Reports</span>
                            <span *ngIf="IsMobile">Summary</span>
                        </a>
                    </li>
                    <li class="nav-item d-none">
                        <a [ngClass]="SubActiveMenu == 'sip' ? 'active' : ''" id="tabdetailed" class="nav-link"
                            data-toggle="tab" role="tab" routerLinkActive="active" data-target="#pills-profile" (click) = "tabDetailed()">
                            <img class="TabImg svg" type="image/svg+xml"
                                pluginspage="http://www.adobe.com/svg/viewer/install/"
                                src="../../../assets/images/JM/Portfolio_Reports/SIP STP SWP Reports_InActive.svg"
                                alt="">
                            <span *ngIf="!IsMobile">Detailed Reports</span>
                            <span *ngIf="IsMobile">Detailed</span>
                        </a>
                    </li>
                    <li class="nav-item" hidden="true">
                        <a [ngClass]="SubActiveMenu == 'online' ? 'active' : ''" class="nav-link" data-toggle="tab"
                            role="tab" routerLinkActive="active" data-target="#pills-contact">
                            <img class="TabImg svg" type="image/svg+xml"
                                pluginspage="http://www.adobe.com/svg/viewer/install/"
                                src="../../../assets/images/JM/Portfolio_Reports/OnlineStatusReports_InActive.svg"
                                alt="">
                            <span *ngIf="!IsMobile">GST Invoice</span>
                            <span *ngIf="IsMobile">GST Invoice</span>
                        </a>
                    </li>
                    <li class="nav-item" hidden="true">
                        <a [ngClass]="SubActiveMenu == 'online' ? 'active' : ''" class="nav-link" data-toggle="tab"
                            routerLinkActive="active" role="tab" data-target="#pills-disabled">
                            <img class="TabImg svg" type="image/svg+xml"
                                pluginspage="http://www.adobe.com/svg/viewer/install/"
                                src="../../../assets/images/JM/Portfolio_Reports/OnlineStatusReports_InActive.svg"
                                alt="">
                            <span *ngIf="!IsMobile">Annual Payout Details</span>
                            <span *ngIf="IsMobile">Annual Payout Details</span>
                        </a>
                    </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <!-- Summary Report -->

                    <div class="tab-pane fade show active my-3 mx-3" id="pills-home" role="tabpanel"
                        aria-labelledby="pills-home-tab">
                        <form [formGroup]="EarningReportSummary" autocomplete="off">
                            <div class="row">
                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
                                    [hidden]="ShowIFDDetailedReport">
                                    <div class="has-float-label">
                                        <select data-placeholder="Select Month"
                                            class="form-control CommonSelectBox TbxMarginBtm classMonth"
                                            required="required" id="SummaryMnth" formControlName="SummaryMnth"
                                            autocomplete="off">
                                            <option value="">Select Month</option>
                                            <option *ngFor="let item of MonthsArray" [value]="item">
                                                {{item}}
                                            </option>
                                        </select>
                                        <label>Month</label>
                                    </div>
                                    <div *ngIf="EarningReportSummary.controls['SummaryMnth'].invalid && formsub">
                                        <small class="text-danger">Month selection is required.</small>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
                                    [hidden]="ShowIFDDetailedReport">
                                    <div class="has-float-label">
                                        <select data-placeholder="Select Year" formControlName="SummaryYear"
                                            class="form-control CommonSelectBox TbxMarginBtm classYear"
                                            required="required" id="SummaryYear" autocomplete="off">
                                            <option value="">Select Year</option>
                                            <option *ngFor="let item of YearsArray" [value]="item">
                                                {{item}}
                                            </option>
                                        </select>
                                        <label>Year</label>
                                    </div>
                                    <div *ngIf="EarningReportSummary.controls['SummaryYear'].invalid && formsub">
                                        <small class="text-danger">Year selection is required.</small>
                                    </div>
                                </div>
                                <div class="summarybuttonclass " [hidden]="ShowIFDDetailedReport">
                                    <!-- Summary report search button -->
                                    <button class="CommonSubmitButton mx-2" (click)="tbnShowSummary()"
                                        [hidden]="ShowIFDDetailedReport">Search</button>
                                    <!-- Summary report Export to PDF -->
                                    <button *ngIf="!IsMobile" [hidden]="!ShowIFDSummaryReport"
                                        class="BtnCommon BtnRed BtnExport ml-2">
                                        <img src="../../assets/images/PDF_Export.svg" class="ExportToIcon"
                                            type="image/svg+xml" fill="#fff" width="12px"
                                            pluginspage="http://www.adobe.com/svg/viewer/install/"
                                            (click)="ExportToPdf_detail_new('Summary')" /></button>
                                    <!-- Summary report Export to PDF -->
                                    <button *ngIf="!IsMobile" [hidden]="!ShowIFDSummaryReport"
                                        class="BtnCommon BtnGreen BtnExport ml-2">
                                        <img src="../../assets/images/Excel_Export.svg" class="ExportToIcon"
                                            type="image/svg+xml" fill="#fff" width="12px"
                                            pluginspage="http://www.adobe.com/svg/viewer/install/"
                                            (click)="ExporttoExcelSummary()" />
                                    </button>




                                </div>

                            </div>
                        </form>

                        <div class="row">
                            <div class="InputBoxOuter fitwidth" [hidden]="!ShowIFDSummaryReport">
                                <div class="FDCards bg-white">



                                    <div id="Section_EarningReport">
                                        <div id="accordion">
                                            <div class="card" id="productheader">
                                                <div class="card-header" data-toggle="collapse" data-target=""
                                                    aria-expanded="true" onmouseover="this.style.cursor='auto';">
                                                    <div class="summaryheader">
                                                        <span class="title fw-bold">Products Names</span>
                                                        <!-- <span class="title fw-bold">Amount (&#x20B9;)</span> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card eachcard"
                                                *ngFor="let item of IFDSummaryAccord;let i = index">
                                                <div class="card-header" data-toggle="collapse"
                                                    [attr.data-target]="'#FAQ_'+i" aria-expanded="true">
                                                    <span class="summaryheader">
                                                        <span class="title fw-bold">{{item.Product}}</span>

                                                    </span>
                                                </div>
                                                <div [attr.id]="'FAQ_'+i" class="accordion-collapse collapse show">
                                                    <div class="card-body">
                                                        <div class="table-responsive table-container pb-3 mt-0"
                                                            id="tbnsumm">
                                                            <table
                                                                class="CommonTable ClsReportTable nowrap CollapsedGroup dataTables datatable_fd"
                                                                width="100%">
                                                                <thead>
                                                                    <tr>

                                                                        <th>Status</th>
                                                                        <th>Product Type</th>
                                                                        <th>Invoice No.</th>
                                                                        <th>Inv Date</th>
                                                                        <th>CN/Dn No.</th>
                                                                        <th>Cheque/NEFT No.</th>
                                                                        <th>Cheque/NEFT Date</th>
                                                                        <th>Brokerage(Excl GST)(A)</th>
                                                                        <th>GST (B)</th>
                                                                        <th>Total Amt (A+B)(Rs.)</th>
                                                                        <th>Recovery Amt(Rs.)</th>
                                                                        <th>TDS (Rs.)</th>
                                                                        <th>Cheque/NEFT Amt (Rs.)</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        *ngFor="let innerItem of bindDataaccording(IFDSummaryReport,item.Product)">

                                                                        <td>{{innerItem.Status}}</td>
                                                                        <td>{{innerItem.Product}}</td>
                                                                        <td>{{innerItem.InvoiceNo}}</td>
                                                                        <td>{{innerItem.InvoiceDate}}</td>
                                                                        <td></td>
                                                                        <td (click)="SummaryToDetails(innerItem.ChequeNo)"
                                                                            class="lbllink">{{innerItem.ChequeNo}}</td>
                                                                        <td>{{innerItem.ChequeDate}}</td>
                                                                        <td>{{innerItem.GrossAmount}}</td>
                                                                        <td>{{innerItem.GST}}</td>
                                                                        <td>{{innerItem.Total}}</td>
                                                                        <td>{{innerItem.RecoveryAmt}}</td>
                                                                        <td>{{innerItem.TDS}}</td>
                                                                        <td>{{innerItem.ChequeAmount}}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>
                        </div>

                        <!-- </div> -->
                    </div>



                    <!-- Detailed Report -->
                    <div class="tab-pane fade my-3 mx-3" id="pills-profile" role="tabpanel"
                        aria-labelledby="pills-profile-tab" tabindex="0" [hidden]="!ShowIFDDetailedReport">
                        <div class="row">
                            <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter" [hidden]="true">
                                    <div class="has-float-label">
                                        <select data-placeholder="Month"
                                            class="form-control CommonSelectBox TbxMarginBtm classMonth"
                                            required="required">
                                            <option *ngFor="let item of MonthsArray">
                                                {{item}}
                                            </option>
                                        </select>
                                        <label>Month</label>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter" [hidden]="true">
                                    <div class="has-float-label">
                                        <select data-placeholder="Year"
                                            class="form-control CommonSelectBox TbxMarginBtm classYear" required="required">
                                            <option *ngFor="let item of YearsArray">
                                                {{item}}
                                            </option>
                                        </select>
                                        <label>Year</label>
                                    </div>
                                </div> -->

                            <div class="summarybuttonclass mx-3 my-3" [hidden]="!ShowIFDDetailedReport">
                                   <!-- Detailed report Export to PDF -->
                                    <!-- <button class="CommonSubmitButton mx-2" (click)="tblShowDetailed()" [hidden]="true">Search</button> -->

                                    <button *ngIf="!IsMobile" class="BtnCommon BtnRed BtnExport ml-2">
                                        <img src="../../assets/images/PDF_Export.svg" class="ExportToIcon"
                                            type="image/svg+xml" fill="#fff" width="12px"
                                            pluginspage="http://www.adobe.com/svg/viewer/install/" (click)="ExportToPdf_detail_new('Detailed')"/></button>
                                    <!-- Detailed report Export to PDF  -->
                                    <button *ngIf="!IsMobile" class="BtnCommon BtnGreen BtnExport ml-2">
                                        <img src="../../assets/images/Excel_Export.svg" class="ExportToIcon"
                                            type="image/svg+xml" fill="#fff" width="12px"
                                            pluginspage="http://www.adobe.com/svg/viewer/install/" (click)="ExporttoExcelDetailed()" /></button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="InputBoxOuter fitwidth" [hidden]="!ShowIFDDetailedReport">
                                <div class="FDCards bg-white">
                                    <div id="accordion1">
                                        <div class="card" id="productheader1">
                                            <div class="card-header" data-toggle="collapse" data-target=""
                                                aria-expanded="true" onmouseover="this.style.cursor='auto';">
                                                <div class="summaryheader">
                                                    <span class="title fw-bold">Products Names</span>
                                                    <!-- <span class="title fw-bold">Amount (&#x20B9;)</span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card eachcard1"
                                            *ngFor="let item of IFDDetailedAccord;let i = index">
                                            <div class="card-header" data-toggle="collapse"
                                                [attr.data-target]="'#FAQ_det_'+i" aria-expanded="true">
                                                <span class="summaryheader">
                                                    <span class="title fw-bold">{{item.Producttypecode}}</span>
                                                    <!-- <i class="fa fa-angle-right rotate-icon"></i> -->
                                                    <!-- <span>{{GetAmountDetailed(IFDDetailedReport,item.Producttypecode)}}</span> -->
                                                </span>
                                            </div>
                                            <div [attr.id]="'FAQ_det_'+i"
                                                class="accordion-collapse collapse pdfclasscollapse show">
                                                <div class="card-body">
                                                    <div class="table-responsive table-container pb-3 mt-0">
                                                        <table
                                                            class="CommonTable ClsReportTable nowrap CollapsedGroup dataTables1"
                                                            width="100%">
                                                            <thead>
                                                                <tr>

                                                                    <th>Investor Name</th>
                                                                    <th>Scheme</th>
                                                                    <th>Txn type</th>
                                                                    <th>Investment Date</th>
                                                                    <th>Invest Amount (Rs.)</th>
                                                                    <th>Folio No/FDR no</th>
                                                                    <th>Brokerage Rate</th>
                                                                    <th>Brokerage Amt(Rs.)</th>
                                                                    <th>Avg Assets</th>
                                                                    <th>Paid Days</th>
                                                                    <th>Brokerage Type</th>
                                                                    <th>Cheque No/Ref no</th>
                                                                    <th>Cheque Date</th>
                                                                    <th>Brokerage From Date</th>
                                                                    <th>Brokerage to Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    *ngFor="let InnerItem of bindDetailedDataaccording(IFDDetailedReport,item.Producttypecode)">

                                                                    <td>{{InnerItem.ClientName}}</td>
                                                                    <td>{{InnerItem.Scheme}}</td>
                                                                    <td>{{InnerItem.TransType}}</td>
                                                                    <td>{{InnerItem.Date}}</td>
                                                                    <td>{{InnerItem.Amount}}</td>
                                                                    <td>{{InnerItem.FolioNo}}</td>
                                                                    <td>{{InnerItem.BrokerageRate}}</td>
                                                                    <td>{{InnerItem.BrokAmtTillDt}}</td>
                                                                    <td>{{InnerItem.AvgAssets}}</td>
                                                                    <td>{{InnerItem.PaidDays}}</td>
                                                                    <td>{{InnerItem.BrokType}}</td>
                                                                    <td>{{InnerItem.ChequeNo}}</td>
                                                                    <td>{{InnerItem.CHQ_NLeftDate}}</td>
                                                                    <td>{{InnerItem.BrokFrmdate}}</td>
                                                                    <td>{{InnerItem.BrokToDate}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- GST Invoice Report -->
                    <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab"
                        tabindex="0">
                        GST Invoice
                    </div>
                    <!-- Annual Payout Details -->
                    <div class="tab-pane fade" id="pills-disabled" role="tabpanel" aria-labelledby="pills-disabled-tab"
                        tabindex="0">
                        Annual
                    </div>
                </div>
            </div>
        </div>

    </div>



</div>

<div >
  <div [ngClass]="!ShowHeaderFooter?'d-none': 'd-block'" id="mainPdfContainer">

    <div id="FirstPage_pdf" class="FirstPage" >
      <div>
        <img class="BannerImg" src="../../../assets/images/JM/pdf/PDFTopBanner.png" />
      </div>
      <div class="ReportInfo">
        <div class="ReportName">{{ReportName}}</div>
        <!-- <div class="ClientName">{{ClientName}}</div> -->
        <div class="Address">{{Address}}</div>
        <div class="ason">Report Generated Date</div>
        <div class="asondate">{{Today | date:'dd-MMM-YYYY'}}</div>
    </div>
    <div class="FooterInfo">
        <div>
          <div class="q">Contact Person</div>
          <div class="a">{{SB_IFD_Name}}</div>
        </div>
        <div>
          <div class="q">Relationship Manager</div>
          <div class="a">{{RM_Name}}</div>
        </div>
        <div>
          <div class="q">Helpdesk</div>
            <!-- <div class="q">customercare@incredmarkets.com</div> -->
            <div class="q">022-45057329</div>
          </div>
        <div>
          <div class="q">Generated date</div>
          <div class="a">{{Today | date:'dd-MMM-YYYY'}}</div>
            <div class="a">{{Today | date:'hh:mm:ss a'}}</div>
          </div>
        </div>
    <div>
      <img class="BottomImg" src="../../../assets/images/JM/pdf/PDFBottomBanner.png" />
    </div>
     </div>

     <div id="Section_EarningReport_pdf">
      <div id="accordion_pdf">
          <div class="card" id="productheader_pdf">
              <div class="card-header" data-toggle="collapse" data-target=""
                  aria-expanded="true" onmouseover="this.style.cursor='auto';">
                  <div class="summaryheader">
                      <span class="title fw-bold">Products Names</span>
                      <!-- <span class="title fw-bold">Amount (&#x20B9;)</span> -->
                  </div>
              </div>
          </div>
          <div class="card eachcard"
              *ngFor="let item of IFDSummaryAccord;let i = index">
              <div class="card-header" data-toggle="collapse"
                  [attr.data-target]="'#FAQ_'+i" aria-expanded="true">
                  <span class="summaryheader">
                      <span class="title fw-bold">{{item.Product}}</span>

                  </span>
              </div>
              <div [attr.id]="'FAQ_'+i" class="accordion-collapse collapse show">
                  <div class="card-body">
                      <div class="table-responsive table-container pb-3 mt-0"
                          id="tbnsumm_pdf">
                          <table
                              class="CommonTable ClsReportTable nowrap CollapsedGroup "
                              width="100%">
                              <thead>
                                  <tr>

                                      <th>Status</th>
                                      <th>Product Type</th>
                                      <th>Invoice No.</th>
                                      <th>Inv Date</th>
                                      <th>CN/Dn No.</th>
                                      <th>Cheque/NEFT No.</th>
                                      <th>Cheque/NEFT Date</th>
                                      <th>Brokerage(Excl GST)(A)</th>
                                      <th>GST (B)</th>
                                      <th>Total Amt (A+B)(Rs.)</th>
                                      <th>Recovery Amt(Rs.)</th>
                                      <th>TDS (Rs.)</th>
                                      <th>Cheque/NEFT Amt (Rs.)</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr
                                      *ngFor="let innerItem of bindDataaccording(IFDSummaryReport,item.Product)">

                                      <td>{{innerItem.Status}}</td>
                                      <td>{{innerItem.Product}}</td>
                                      <td>{{innerItem.InvoiceNo}}</td>
                                      <td>{{innerItem.InvoiceDate}}</td>
                                      <td></td>
                                      <td (click)="SummaryToDetails(innerItem.ChequeNo)"
                                          class="lbllink">{{innerItem.ChequeNo}}</td>
                                      <td>{{innerItem.ChequeDate}}</td>
                                      <td>{{innerItem.GrossAmount}}</td>
                                      <td>{{innerItem.GST}}</td>
                                      <td>{{innerItem.Total}}</td>
                                      <td>{{innerItem.RecoveryAmt}}</td>
                                      <td>{{innerItem.TDS}}</td>
                                      <td>{{innerItem.ChequeAmount}}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

    <div id="LastPage" class="LastPage" >
      <div class="FooterInfo ifdDetails">
        <!-- <div>
          <div class="q">Client Name</div>
              <div class="a text-upper">{{ClientName}}</div>
          </div> -->
          <div>
              <div class="q">Report Generated Date</div>
              <div class="a">{{Today | date:'dd-MMM-YYYY'}}</div>
          </div>
          <div>
            <img class="LogoImg" src="../../../assets/images/InCred_capital_NewLogo.svg" />
          </div>
        </div>
        <div class="FooterContent">
          <div class="Disclaimer">Disclaimer</div>
          <div class="Content">
            This Statement/Report has been prepared based on the information available with Incred Markets (Incred Markets) and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies any other external agencies, etc. which Incred Markets believes to be reliable. The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report. The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by Incred Markets/ RTA / AMC/Issuers/Companies, etc. at any point of time. Incred Markets reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change. The above Statement/Report is not available on a real time basis. Incred Markets or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.
            </div>
            <div class="Disclaimer">NOTE 1</div>
            <div class="Content">
              In case you need any information/clarification about any of the reports, please contact your relationship manager/branch at Incred Markets.
            </div>
            <div class="Disclaimer">NOTE 2</div>
            <div class="Content">
              The Income statement is a listing of all the NEFTs /cheques which have been issued to you during the selected period. Payment of sub-brokerage/commissions/fees is subject to receipt of the same from the Issuers/Companies/ AMCs/RTAs. Incred Markets reserves the right to cancel the NEFT /cheque request towards such payment before crediting/dispatching the same to your bank account. The statement will undergo change, if any NEFT /cheque is issued and subsequently gets cancelled. On clicking the NEFT no./cheque no., you will be able to see transactional brokerages paid pertaining to those NEFTs/cheques. While Incred Markets has taken maximum care to identify your own investments and not pay brokerage to you on the same, however, if there is any payment made erroneously, we advise you to refund the same to Incred Markets immediately to comply with SEBI/AMFI regulations."
            </div>
            <div class="Disclaimer">NOTE 3</div>
            <div class="Content">
              You may observe a minor difference in NEFT/cheque gross amount and the brokerage details fetched on hyperlink of NEFT no./cheque no. The reason being the brokerage amount is rounded off at transaction level in this report. However NEFT/Cheque amount is the actual amount paid to you.
            </div>
            <div class="Disclaimer">NOTE 4</div>
            <div class="Content">
              You may observe a minor difference between the brokerage rate as per the payout structure circulated to you (which is rounded off upto 2 decimals for convenience) and the brokerage rates with which we actually pay at transaction level, as shown in this report, which may be upto 4 decimals.
            </div>
          <div class="Regd">
              <div><span>Incred Markets</span></div>
              <!-- <div><span>Regd Off: </span>7th Floor, Appasaheb Marathe Marg,Prabhadevi, Mumbai - 400 025.
                  Telephone :
                  022- 66303030 Fax: 022- 6630 3223, CIN:U67120MH1998PLC115415, ARN-0002</div> -->
                </div>
              </div>
              <div>
                <img class="BottomImg" src="../../../assets/images/JM/pdf/PDFBottomBanner.png" />
      </div>
    </div>
</div>
</div>

